import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function VerticalBar({
  marginInlineStart = '0',
  marginInlineEnd = '0'
}) {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    blockSize: "20px",
    borderInlineStartColor: "border-core-subtle",
    borderInlineStartStyle: "solid",
    borderInlineStartWidth: "100",
    inlineSize: "100",
    marginInlineEnd: marginInlineEnd,
    marginInlineStart: marginInlineStart
  });
}
export default VerticalBar;